import axios from '../axios';

export const all = (params = {}) => {
  return axios.get('/wholesale-representatives', params);
};

export const show = (id, params = {}) => {
  return axios.get(`/wholesale-representatives/${id}`, params);
};

export const create = (payload) => {
  return axios.post('/wholesale-representatives', payload);
};

export const update = (id, payload) => {
  return axios.put(`/wholesale-representatives/${id}`, payload);
};

export const destroy = (id) => {
  return axios.delete(`/wholesale-representatives/${id}`);
};
